/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PreviousMotorVehicleLiabilityInsurance } from './previousMotorVehicleLiabilityInsurance';
import { PreviousFullyComprehensiveInsurance } from './previousFullyComprehensiveInsurance';
import { PreviousPartialComprehensiveInsurance } from './previousPartialComprehensiveInsurance';
import { PreviousDamages } from './previousDamages';

/**
 * @type PreviousMotorVehicleElementaryProduct
 * @export
 */
export type PreviousMotorVehicleElementaryProduct =
  | PreviousFullyComprehensiveInsurance
  | PreviousMotorVehicleLiabilityInsurance
  | PreviousPartialComprehensiveInsurance;
